import React from 'react';
import "components/shared/icon-btn/style.scss";
import $ from "jquery";

export const IconBtn = (props) => {

    const { id, size, onClick, className, icon, tooltip } = props;
    //ENABLE BOOTSTRAP TOOLTIPS
    $(() => {
        $('[data-toggle="tooltip"]').tooltip();
    });

    return (
        <span
            id={id}
            data-toggle="tooltip"
            title={tooltip}
            className={`${className} icon-btn`}
            onClick={onClick}>
            <i className={`${icon}`} style={{ fontSize: size }} />
        </span>
    );
}